import { Location } from 'iconsax-react'
import Autocomplete from 'react-google-autocomplete'

import Env from '@/env/env'
import type { GooglePlace } from '@/pages/RunReport/utils/applyGooglePlaceToForm'
import { weCheckPalette } from '@/utils/palette/weCheckPalette'

interface LocationAutocompleteProps {
  onPlaceSelected: (place: GooglePlace) => void
  defaultValue?: string
  placeholder?: string
}

export const LocationAutocomplete = ({
  onPlaceSelected,
  defaultValue,
  placeholder,
}: LocationAutocompleteProps) => (
  <div className="relative">
    <Autocomplete
      apiKey={Env.GOOGLE_KEY as string}
      onPlaceSelected={onPlaceSelected}
      options={{ types: ['(regions)'] }}
      defaultValue={defaultValue}
      placeholder={placeholder}
      className="flex h-[46px] w-full rounded-lg border border-neutralColor5 bg-baseColorHighlight pl-3 pr-10 text-sm shadow-sm transition-colors placeholder:text-neutralColor60 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    />
    <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2">
      <Location size="16" color={weCheckPalette.neutralColor60} />
    </span>
  </div>
)
